import { Button } from "@/components/button";
import { useDesignMaxTheme } from "@/packages";
import { FONT } from "@/styles";
import { Center, Flex, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useCountPerson, useMaxPerson } from "../../hooks";
import { type PersonCountProps } from "./personCount.type";

export const PersonCount = ({ addFee, addPerson, personOfCapacity, ...rest }: PersonCountProps) => {
    const { handleCountPerson, personCountMap } = useCountPerson({
        ...personOfCapacity,
        ...addFee,
        ...rest,
    });
    const { isAvailableBook } = rest;
    const [isOpenHandlerCount, setIsOpenHandlerCount] = useState(false);
    const { handleMaxPerson } = useMaxPerson({ personOfCapacity });
    const { COLORS } = useDesignMaxTheme();

    return (
        <Center w="100%" flexDir="column" rowGap="8px" alignItems="flex-start" position="relative">
            <Center
                w="100%"
                p="0 16px"
                h="40px"
                border="1px solid"
                borderColor={COLORS.gray[300]}
                justifyContent="space-between"
                cursor="pointer"
                onClick={() => isAvailableBook && setIsOpenHandlerCount((prev) => !prev)}
            >
                <Text>
                    성인 : {personCountMap[0]}명 / 아동 : {personCountMap[1]}명 / 유아 : {personCountMap[2]}명
                </Text>
                <span className="material-icons-outlined">
                    {isOpenHandlerCount ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                </span>
            </Center>
            {isOpenHandlerCount && (
                <Center
                    w="100%"
                    flexDir="column"
                    rowGap="24px"
                    p="24px 16px"
                    position="absolute"
                    top="48px"
                    zIndex="100"
                    bgColor="white"
                    border="1px solid"
                    borderColor={COLORS.gray[300]}
                >
                    <Center w="100%" flexDir="column" rowGap="16px">
                        {addPerson.map((person, idx) => {
                            const { [idx as 0 | 1 | 2]: currentState } = personCountMap;
                            const { ageRange, type } = person;

                            return (
                                <Center key={type} w="100%" boxSizing="border-box" justifyContent="space-between">
                                    <Flex w="128px" justifyContent="flex-start" flexDir="column" flexShrink={0}>
                                        <Text fontSize="16px" sx={{ ...FONT("pretendard", 16, 500) }}>
                                            {type}
                                        </Text>
                                        <Text fontSize="12px" fontWeight="300">
                                            {ageRange && ageRange?.max > 0
                                                ? `${ageRange.min}세 이상 ~ ${ageRange.max}세 이하`
                                                : ""}
                                        </Text>
                                    </Flex>
                                    <Center
                                        sx={{
                                            "& > button": {
                                                w: "36px",
                                                h: "36px",
                                                p: "0",
                                                border: "1px solid",
                                                borderColor: COLORS.gray[400],
                                                "&:hover": {
                                                    bgColor: COLORS.gray[300],
                                                },
                                            },
                                        }}
                                    >
                                        <Button round="full" onClick={(e) => handleCountPerson(e, idx, currentState)}>
                                            -
                                        </Button>
                                        <Center flexShrink={0} w="36px" h="36px">
                                            {currentState}
                                        </Center>
                                        <Button
                                            round="full"
                                            onClick={(e) => {
                                                handleCountPerson(e, idx, currentState);
                                                handleMaxPerson(e, personCountMap);
                                            }}
                                        >
                                            +
                                        </Button>
                                    </Center>
                                </Center>
                            );
                        })}
                    </Center>
                    <Center
                        w="100%"
                        justifyContent="space-between"
                        sx={{
                            "& > button": { w: "auto", textDecoration: "underline", ...FONT("pretendard", 16, 700) },
                        }}
                    >
                        <Text color={COLORS.gray[500]} sx={{ ...FONT("pretendard", 14, 300) }}>
                            최대 숙박 인원은 영유아 포함 {personOfCapacity.max}명 입니다.
                        </Text>
                        <Button border="none" onClick={() => setIsOpenHandlerCount(false)}>
                            닫기
                        </Button>
                    </Center>
                </Center>
            )}
        </Center>
    );
};
